var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "msp-planned-calculated-budget" }, [
    _c("div", { staticClass: "msp-planned-calculated-budget__budgets" }, [
      _c(
        "div",
        { staticClass: "msp-planned-calculated-budget__title" },
        [
          _c("pui-headline", { attrs: { type: "h6" } }, [
            _vm._v(" " + _vm._s(_vm.$t("plannedAndCalculatedBudget")) + " "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "msp-planned-calculated-budget__chart" },
        [_c("echarts", { attrs: { option: _vm.plannedCalculatedOption } })],
        1
      ),
      _c("div", { staticClass: "msp-planned-calculated-budget__footer" }, [
        _vm._v(" " + _vm._s(_vm.$t("year")) + " "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }